import palette from './palette';
export default function colorSet(baseColors, colorMapping, noCache) {
  const colorClasses = Object.keys(baseColors);
  return colorClasses.reduce((palettes, colorClass) => {
    return Object.assign(Object.assign({}, palettes), {
      [colorClass]: palette(baseColors[colorClass], colorMapping, noCache)
    });
  }, {});
}